import { HttpClient } from '#client/http/index'
import { IntroductionMaterialRequestParams } from '#client/resources/index'

/**
 * 紹介資料請求フォームを送信する (未認証で利用可。成功時は 204)
 */
export const submitIntroductionMaterialRequest = async (
  { httpClient }: { httpClient: HttpClient },
  params: IntroductionMaterialRequestParams,
) => {
  return await httpClient.post(
    '/user/inquiries/introductionMaterialRequest',
    params,
  )
}
